// extracted by mini-css-extract-plugin
export default {"userAddPanel":"UserAddPanel_userAddPanel__5nyOr"};